const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  /** Open cart drawer UI (e.g. after add, or without a full cart refresh). */
  cartDrawerOpen: "cart-drawer-open",
  variantChange: "variant-change",
  cartError: "cart-error",
  cartItemRemove: "cart-item-remove",
  quantityUpdate: "quantity-update",
};
